import React from 'react';

import * as S from './styled';

const Button = props => (
  <S.Button onClick={props.method} bg={ props.background } disabled={ props.disabled } >{ props.text }</S.Button>
);

export default Button;